import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import { getCategories } from "../../../../common/services/purchaseCategory.api";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";

import "./ModalAddCategory.scss";
import { IPurchaseCategory } from "../../../../types/purchaseCategory.type";
import ComboBoxFormik from "../../../../common/components/form/ComboBoxFormik";
import { IPurchaseCostCenter } from "../../../../types/purchaseCostCenter";
import { updateCostCenter } from "../../../../common/services/purchaseCostCenter.api";
import * as Yup from "yup";

type Props = {
  saveCostCenter: (pieceData: IPurchaseCostCenter)
    => Promise<{ ok: boolean; data: IPurchaseCostCenter; errors: [{ message: string; path: string[]; }]; }>;
  onClose?: () => void;
  onSave: (data: IPurchaseCostCenter) => void;
  costCenter: IPurchaseCostCenter;
}

const validationSchema = Yup.object().shape({
  categoriesId: Yup.array()
    .required('Selecione Uma Categoria')
    .test(
      'array-empty',
      'Deve selecionar uma categoria',
      value => {
        return value.filter(el => el).length > 0;
      }
    )
});

export default function ModalAddCategory(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<IPurchaseCategory[]>([]);

  const handleCloseModal = () => { props.onClose && props.onClose(); }

  useEffect(() => {
    async function loadCategories() {
      const result = await getCategories();
      setCategories(result.data);
    }
    loadCategories();
  }, []);

  const initialValues = {
    ...props.costCenter,
    categoriesId: []
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (data: IPurchaseCostCenter) => {

      delete data.categoriesIds;
      setLoading(true);
      const result = await updateCostCenter(data);
      if (!result.ok && result.message) {
        notifyError(result.message);
      }
      setLoading(false);
      notifySuccess("Adicionado Categoria com sucesso.");
      props.onSave(data);
    }
  });

  return (
    <Modal
      className='relative text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{'Adicionar Categoria'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormikProvider value={formik}>
          <ComboBoxFormik
            label="Selecione a Categoria"
            name="categoriesIds"
            options={[{ label: '', value: '' }, ...categories.map(category => ({ label: category.name, value: category._id }))]}
            onChange={async value => {
              await formik.setFieldValue('categoriesId', []);
              await formik.setFieldValue('categoriesId', (!props.costCenter.categoriesId.includes(value as string) && (value as string).length) ? [...props.costCenter.categoriesId, value as string] : []);
            }}
          ></ComboBoxFormik>
        </FormikProvider>
        <div className="containerButtonCategory">
          <ButtonWithLoader disabled={Object.keys(formik.errors).length > 0 ? true : false} isLoading={loading} onClick={formik.handleSubmit}>Adicionar</ButtonWithLoader>
        </div>
      </Modal.Body>
    </Modal>
  );
}